import type { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import type { SchemaEuropaceOffer } from 'cpool-schemas';
import type {
    SchemaLoanRequestResolver_Get,
    SchemaLoanRequestResolver_GetOffersByRequestId,
} from 'cpool-tables/backend-resolvers';

import { BankOfferResultsRow } from './BankOfferResultsRow';

type Props = {
    lead: SchemaLoanRequestResolver_Get;
    isOdd: boolean;
    createdAt: Extract<
        NonNullable<SchemaLoanRequestResolver_GetOffersByRequestId>[number],
        { source: typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE }
    >['createdAt'];
    requestId?: string;
    source: typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE;
    offer: SchemaEuropaceOffer;
};

export const EuropaceOfferResultsRow = ({ createdAt, isOdd, lead, offer, requestId, source }: Props) => {
    const kreditbetrag = offer.gesamtkonditionen?.nettokreditbetrag;
    const rateMonatlich = offer.gesamtkonditionen?.rateMonatlich;
    const laufZeit = offer.gesamtkonditionen?.laufzeitInMonaten;
    const zinsen = offer.gesamtkonditionen?.effektivzins;
    const insuranceApplicant1 = offer.ratenschutz?.versicherteRisikenAntragsteller1 ?? [];
    const insuranceApplicant2 = offer.ratenschutz?.versicherteRisikenAntragsteller2 ?? [];
    const creationString = createdAt.toISOString();

    return (
        <BankOfferResultsRow
            createdAt={creationString}
            isOdd={isOdd}
            lead={lead}
            requestId={requestId}
            source={source}
            offer={offer}
            insuranceApplicant1={insuranceApplicant1}
            insuranceApplicant2={insuranceApplicant2}
            kreditbetrag={kreditbetrag}
            laufZeit={laufZeit}
            monatlicheRate={rateMonatlich}
            zinsen={zinsen}
        />
    );
};
